import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["element"];

  connect() {
    if (!this.isTouchDevice()) {
      window.addEventListener("mousemove", this.handleMouseMove);
    }
  }

  disconnect() {
    if (!this.isTouchDevice()) {
      window.removeEventListener("mousemove", this.handleMouseMove);
    }
  }

  isTouchDevice() {
    return (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0));
  }

  handleMouseMove = (event) => {
    const x = event.clientX;
    const y = event.clientY;

    const middleX = window.innerWidth / 2;
    const middleY = window.innerHeight / 2;

    const offsetX = ((x - middleX) / middleX) * 10;
    const offsetY = ((y - middleY) / middleY) * 10;

    this.elementTarget.style.setProperty("--rotateX", `${-offsetY}deg`);
    this.elementTarget.style.setProperty("--rotateY", `${offsetX}deg`);
  };
}
